import { useRef, useState, useEffect } from 'react';
import style from './index.m.less';
import { Input, Tag } from 'antd';
import { cloneDeep } from 'lodash';
const TagInput = (props) => {
    const inputRef = useRef(null),
        [first, setFirst] = useState(true),
        [tags, setTags] = useState([]),
        [value, setValue] = useState(),
        [actived, setActived] = useState(false),
        [placeholder] = useState(props.placeholder || '');
    useEffect(() => {
        if (props.value) {
            setTags(props.value);
        }
    }, [props.value]);
    //第一次加载，阻止触发表单验证
    useEffect(() => {
        if (first) {
            setFirst(false);
        } else {
            props?.onChange(tags); //注入表单验证
        }
    }, [tags]);
    //生成tag数据，去重 + 清空input
    const handleTags = () => {
            // 去空格后的有效值
            let v = value?.trim();
            if (v && !tags.includes(v)) {
                let data = cloneDeep(tags);
                data.push(v);
                setTags(data);
                setValue('');
            } else {
                setValue('');
            }
        },
        //按enter 生成tag
        onKeyUp = (e) => {
            if (e.keyCode === 13) {
                handleTags();
            }
        };
    //设置聚焦样式
    let onFocus = () => {
        setActived(true);
    };
    // 失焦生成tag + 取消聚焦样式
    const onBlur = () => {
            handleTags();
            setActived(false);
        },
        //删除tags
        onClose = (index) => {
            let data = cloneDeep(tags);
            data.splice(index, 1);

            setTags(data);
        },
        //修改input值
        onChange = (e) => {
            setValue(e.target.value);
        };

    return (
        <div className={`${style['box-wrap']} ${actived ? style['actived'] : ''}`}>
            {tags.length ? (
                <div className={style['tag-wrap']} id={props.en_name + 'tag'}>
                    {tags.map((ele, index) => {
                        return (
                            <Tag
                                key={ele}
                                className={`${style['item-tag']}`}
                                closable
                                onClick={(e) => {
                                    e.stopPropagation();
                                    inputRef.current.focus();
                                }}
                                onClose={(e) => {
                                    e.preventDefault();
                                    onClose(index);
                                }}
                            >
                                <span className={`${style['item-tag-span']}`}>{ele}</span>
                            </Tag>
                        );
                    })}
                </div>
            ) : null}

            <Input
                ref={inputRef}
                // bordered={false}
                onBlur={(e) => {
                    e.stopPropagation();
                    onBlur();
                }}
                onFocus={(e) => {
                    e.stopPropagation();
                    onFocus();
                }}
                onKeyUp={onKeyUp}
                // {...props} // onBlur不起作用
                onChange={onChange}
                value={value}
                placeholder={placeholder}
                style={{ border: 'none', '--text-align': 'left', height: 40 }}
            />
        </div>
    );
};
export default TagInput;
